import styled from "styled-components";

export const GreyLine = styled.div`
  width: 100%;
  height: 1.3px;
  background-color: #212529;
`;
